import React from 'react';
import "./App.css";
import "./styles/themes.css";
import { Route, Routes } from "react-router-dom";
import LogIn from "./Component/Login/Login";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "bootstrap/dist/js/bootstrap.bundle";

import Home from "./Component/Home";
import SalesFloor from "./Component/SalesFloor";
import PrivateRoute from './routes/PrivateRoute';
import ProfileRedirect from './routes/ProfileRedirect';
import AutoRedirect from './routes/AutoRedirect';
import { ThemeProvider } from './context/ThemeContext';

import Pusher from "pusher-js"
import { PusherProvider } from "./context/pusherContext";
// Pusher.logToConsole = true;

const pusher = new Pusher(process.env.REACT_APP_PUSHER_CONFIG_KEY ?? '', {
  cluster: process.env.REACT_APP_PUSHER_CONFIG_CLUSTER ?? '',
  forceTLS: true,
})

function App() {
  return (
    <PusherProvider pusher={pusher}>
      <ThemeProvider>
        <Routes>
          {/* Ruta raíz que redirige automáticamente según el perfil */}
          <Route
            path="/"
            element={
              <PrivateRoute>
                <ProfileRedirect allowedProfiles={['Cocina', 'Administrador']}>
                  <Home />
                </ProfileRedirect>
              </PrivateRoute>
            }></Route>

          {/* Ruta de piso de venta */}
          <Route
            path="/sales-floor"
            element={
              <PrivateRoute>
                <ProfileRedirect allowedProfiles={['PisoVenta', 'Administrador']}>
                  <SalesFloor />
                </ProfileRedirect>
              </PrivateRoute>
            }></Route>

          {/* Ruta de auto-redirección para usuarios logueados */}
          <Route path="/auto-redirect" element={<AutoRedirect />} />

          {/* Ruta de login */}
          <Route path="/login" element={<LogIn />} />
        </Routes>
      </ThemeProvider>
    </PusherProvider>
  );
}

export default App;
